export class TaxaEntregaFormModel {
    constructor(
        public valor: number = 0,
        public tipoEntrega: 'propria' | 'terceirizada' = 'propria',
    ) { }
}